export const QueryKeys = {
  login: () => ['login'],
  user: () => ['user'],
  document: (sessionId: string, documentId: string) => [
    'document',
    sessionId,
    documentId
  ],
  folders: (
    id?: string,
    offset?: number,
    limit?: number,
    searchQuery?: string,
    sortField?: string,
    sortDirection?: string
  ) => {
    if (!id) {
      return [
        'folders',
        offset ?? 0,
        limit ?? 25,
        searchQuery ?? '',
        sortField ?? '',
        sortDirection ?? ''
      ];
    }
    return [
      'folders',
      id,
      offset ?? 0,
      limit ?? 25,
      searchQuery ?? '',
      sortField ?? '',
      sortDirection ?? ''
    ];
  },
  session: (sessionId: string) => ['transcript-editor-session', sessionId],

  reseller: (customerId?: string, data?: Record<string, unknown>) => {
    if (!customerId) {
      return ['reseller'];
    }
    return ['reseller', customerId, data];
  },
  qrCode2fa: () => ['qrCode2fa'],
  backupCodes2fa: () => ['backupCodes2fa'],
  exportTemplates: () => ['exportTemplates'],
  exportTempalte: (templateId: number) => ['exportTemplate', templateId],
  exportTemplateItems: () => ['exportTemplateItems'],
  exportTemplateItem: (itemId: number) => ['exportTemplateItem', itemId],
  UserPreferences: () => ['userPreferences'],
  speakers: (
    offset?: number,
    limit?: number,
    searchQuery?: string,
    sortField?: string,
    sortDirection?: string
  ) => [
    'speakers',
    offset ?? 0,
    limit ?? 25,
    searchQuery ?? '',
    sortField ?? '',
    sortDirection ?? ''
  ],
  speaker: (speakerId: number) => ['speaker', speakerId],
  tags: (
    offset?: number,
    limit?: number,
    searchQuery?: string,
    sortField?: string,
    sortDirection?: string
  ) => [
    'tags',
    offset ?? 0,
    limit ?? 25,
    searchQuery ?? '',
    sortField ?? '',
    sortDirection ?? ''
  ],
  tag: (tagId: number) => ['tag', tagId],
  tagAssignments: (sessionId: string, documentId: string) => [
    'tagAssignments',
    sessionId,
    documentId
  ],
  documentTranslations: (sessionId: string, documentId: string) => [
    'documentTranslations',
    sessionId,
    documentId
  ],
  translationQuote: (sessionId: string, documentId: string) => [
    'translationQuote',
    sessionId,
    documentId
  ],
  connections: () => ['connections'],
  connectionPlatforms: () => ['connectionPlatforms'],
  connection: (connectionId: string) => ['connection', connectionId],
  publishTargets: (connectionId: string, query?: string) => [
    'publishTargets',
    connectionId,
    query ?? ''
  ],
  publishJob: (jobId: string) => ['publishJob', jobId],
  documentPublishHistory: (sessionId: string, documentId: string) => [
    'documentPublishHistory',
    sessionId,
    documentId
  ]
};
